// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"loader_spinnerContainer__2pwCc","spinnerWrapper":"loader_spinnerWrapper__WZR6z","spinner":"loader_spinner__uX1Ok","spin":"loader_spin__3SITo"};